import { DatePicker } from 'antd';
import React from 'react';

import type { DatePickerProps, GetProps } from 'antd';

type RangePickerProps = GetProps<typeof DatePicker.RangePicker>;

const { RangePicker } = DatePicker;

export const DateRange = ({
  onChange,
  value,
}: {
  onChange?: (value: RangePickerProps['value']) => void;
  value?: RangePickerProps['value'];
}) => {
  const onOk = (
    value: DatePickerProps['value'] | RangePickerProps['value']
  ) => {};

  const disableDate: DatePickerProps['disabledDate'] = (current, { from }) => {
    return (
      current.valueOf() / 1000 <
        Math.floor(Date.now() / 1000) - 1 * 24 * 60 * 60 ||
      current.day() === 0 ||
      current.day() === 6
    );
  };

  return (
    <RangePicker
      format="DD-MM-YY"
      placeholder={['Startdatum', 'Einddatum']}
      value={value}
      defaultValue={value}
      locale={['BE']}
      disabledDate={disableDate}
      style={{ width: '100%' }}
      allowEmpty={true}
      onChange={onChange}
      onOk={onOk}
    />
  );
};

export default DateRange;
